module.exports = __webpack_public_path__ + "static/media/products-2.a08b7bb3.svg";